import React from 'react';
import { Input, Button, Form, Card, message, Select, DatePicker } from 'antd';
import { FormInstance } from 'antd/lib/form';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import './page-contact.less';
import ContactService, { ContactPostParam, ContactPutParam, IContactInfo } from '../../service/contact/ContactService';
import { ADD_CONTACT_SUCCESS_MESSAGE, ADD_CONTACT_ERROR_MESSAGE, EDIT_CONTACT_ERROR_MESSAGE, EDIT_CONTACT_SUCCESS_MESSAGE,
         GET_CONTACT_ERROR_MESSAGE, GET_CUSTOMER_ERROR_MESSAGE} from '../../config/strcfg';
import ErrorBoundary from 'antd/lib/alert/ErrorBoundary';
import moment from 'moment';
import SearchSelectComponent from '../../components/public/SearchSelectComponent';
import CustomerService, { ICustomerInfo } from '../../service/customer/CustomerService';


interface ContactManagerPageState {
  loading: boolean;
  isEditMode: boolean;
  contactData: IContactInfo;
  customerData: ICustomerInfo[]
}

// 从 URL 中获取参数
const getUrlParams = () => {
  const hash = window.location.hash;
  const queryString = hash.split('?')[1];
  const urlParams = new URLSearchParams(queryString);
  
  return {
      customerName: decodeURIComponent(urlParams.get('customerName')),
      customerId: parseInt(urlParams.get('customer')),
      companyId: parseInt(urlParams.get('companyId')),
      contactId: parseInt(urlParams.get('id')),
  };
};

class ContactManagerPage extends React.Component<ContactManagerPageState> {
  state : ContactManagerPageState = {
    loading: false,
    isEditMode: false,
    contactData: null,
    customerData: [],
  };
  
  async componentDidMount() {
    let companyId = null;
    //根据url判断展示添加or编辑页面模式
    const contactId = getUrlParams().contactId;

    //编辑沟通信息页面模式
    if(contactId){
      this.setState({ isEditMode: true, loading: true });
      //编辑页面需要调用沟通信息查询接口
      try{
        const response = await ContactService.getContactInfoById(contactId);
        if(response && response.data && response.data.contactInfo){
          this.setState({ contactData:response.data.contactInfo, loading: false }); 
          // 在此处添加条件判断，确保contactData有值之后再设置value属性
          if (this.state.contactData) {
            this.formRef.current?.setFieldsValue({ 
              company: this.state.contactData.company,
              customer: this.state.contactData.customer,
              customerName: this.state.contactData.customerName,
              sales: this.state.contactData.sales,
              time: moment(this.state.contactData.time),
              tools: this.state.contactData.tools,
              way: this.state.contactData.way ?? 0, // Default to 0 if way is null/undefined
              requirement: this.state.contactData.requirement,
              content: this.state.contactData.content,
              remark: this.state.contactData.remark,
            });
            companyId = this.state.contactData.company;
          }
          else{
            this.setState({ contactData: null });
            message.error(GET_CONTACT_ERROR_MESSAGE);
          }
        }
        else{
          this.setState({ contactData: null });
          message.error(GET_CONTACT_ERROR_MESSAGE);
        }
      } catch(error){
        message.error(GET_CONTACT_ERROR_MESSAGE);
      } finally{
        this.setState({ loading: false });
      }
    }
    //添加客户沟通信息页面模式
    else{
      this.setState({ isEditMode: false });
      companyId = getUrlParams().companyId;
    }

    //获取公司内客户信息用于客户选择框内容展示
    try {
      const response = await CustomerService.getCustomerByCompanyId(companyId, {pageNo: 1, pageSize: 99999});
      if (response && response.data && response.data.customerInfoList) {
        const customerRecords = response.data.customerInfoList.records || [];
        const customerData = customerRecords.map((item: any) => ({
          id: item.id,
          cname: item.cname
        }));
        this.setState({ customerData }, () => {
          // 设置初始选中值
          if (this.state.isEditMode && this.state.contactData) {
            this.formRef.current?.setFieldsValue({
              customerName: this.state.contactData.customerName,
              customer: this.state.contactData.customer
            });
          }
          else{
            if(getUrlParams().customerName && getUrlParams().customerId){
              this.formRef.current?.setFieldsValue({
                customerName: getUrlParams().customerName,
                customer: getUrlParams().customerId
              });
            }
            else{
              message.error(GET_CUSTOMER_ERROR_MESSAGE);
            }
          }
        });
      }
    } catch (error) {
      message.error(GET_CUSTOMER_ERROR_MESSAGE);
    }

  }

  formRef = React.createRef<FormInstance>();

  // 返回按钮点击事件处理
  handleBackButtonClick = () => {
      window.history.back();
  };

  //权限选择框事件处理(不写这个空方法会导致页面任何操作都会使RoleSelect执行useEffect的接口调用)
  handleRoleSelectData = () => {
  };

  onFinish = async (params: any) => {
    this.setState({ loading: true });
    //调用addContact接口
    if(!this.state.isEditMode){
      try {
        const response = await ContactService.addContact(params as ContactPostParam);
        if(response && response.success){
          // 添加成功后的操作
          this.formRef.current?.resetFields();
          message.success(ADD_CONTACT_SUCCESS_MESSAGE);
        }
        else{
          // 添加失败后的操作
          message.error(response.message);
        }
      } catch (error) {
          message.error(ADD_CONTACT_ERROR_MESSAGE);
      } finally {
          this.setState({ loading: false });
      }
    }
    //调用editContact接口
    else{
      try {
        const updatedParams = {
          ...params,  
          id: this.state.contactData.id  
        };
        const response = await ContactService.updateContact(updatedParams as ContactPutParam);
        if(response && response.success){
          // 编辑成功后的操作
          this.formRef.current?.resetFields();
          message.success(EDIT_CONTACT_SUCCESS_MESSAGE);
          // 在提交表单后等待500ms再刷新页面，加载提交后的数据
          setTimeout(() => { window.location.reload(); }, 500);
        }
        else{
          // 编辑失败后的操作
          this.formRef.current?.resetFields();
          message.error(response.message);
          setTimeout(() => { window.location.reload(); }, 500);
        }
      } catch (error) {
          this.formRef.current?.resetFields();
          message.error(EDIT_CONTACT_ERROR_MESSAGE);
          setTimeout(() => { window.location.reload(); }, 500);
      } finally {
          this.setState({ loading: false });
      }
    }
    
  };

  render() {
    
    //form 初始值
    const initialValues = this.state.isEditMode && this.state.contactData
    ? {
        company: this.state.contactData.company || '',
        customer: this.state.contactData.customer || '',
        customerName: this.state.contactData.customerName || '',
        sales: this.state.contactData.sales || '',
        time: moment(this.state.contactData.time),
        tools: this.state.contactData.tools || '',
        way: this.state.contactData.way ?? 0, // Default to 0 if way is null/undefined
        requirement: this.state.contactData.requirement || '',
        content: this.state.contactData.content || '',
        remark: this.state.contactData.remark || '',
      }
    : {
        customerName: getUrlParams().customerName || '',
        company: getUrlParams().companyId || '',
        customer: getUrlParams().customerId || '',
        time: moment(), // Default to today
        way: 0, // Default to 'Out'
      };

    const cardTitle = this.state.isEditMode ? "编辑客户沟通信息" : "添加客户沟通信息"; 
    return (
      this.state.loading === false ?
      <ErrorBoundary>
        <div className="page-contact_container">
          <BreadcrumbCustom breads={['客户沟通信息管理', this.state.isEditMode ? '编辑客户沟通信息' : '添加客户沟通信息']} />
          <Card 
            title={
                <div className="title-manager_page">
                    <Button type="link" className="back-button" onClick={this.handleBackButtonClick}>{'< 返回'}</Button>
                    {cardTitle}
                </div>
            } 
            bordered={false}
          >
              <div className="add-contact_container">

                <Form ref={this.formRef} onFinish={this.onFinish} initialValues={initialValues}>
                  <Form.Item name="customer" hidden>
                    <Input type="hidden" />
                  </Form.Item>
                  <Form.Item name="company" hidden>
                    <Input type="hidden" />
                  </Form.Item>

                  <Form.Item label="客户姓名" name="customer" className="formItem-select" rules={[{ required: true , message: '请选择沟通的客户' }] } >
                    <SearchSelectComponent 
                      placeholder="请选择客户" 
                      optionProps={this.state.customerData.map(customer => ({
                        key: customer.id,
                        value: customer.cname,
                        label: customer.cname 
                      }))} 
                      initialValues={initialValues.customerName}
                      onChange={(key, value) => {
                        this.formRef.current?.setFieldsValue({
                          customer: key,
                          customerName: value
                        });
                      }}
                      allowClear={false}
                    />
                  </Form.Item>

                  <Form.Item label="沟通时间" name="time" className="formItem-contact" 
                             rules={[{ required: true ,message: '请选择沟通时间' }]}
                  >
                    <DatePicker 
                        style={{ width: '73%' }}
                        placeholder="请选择沟通时间"
                        format="YYYY-MM-DD"
                        disabledDate={current => { return current && current > moment().endOf('day'); }}
                    />
                  </Form.Item>

                  <Form.Item label="沟通内容" name="content" className="formItem-content" rules={[{ required: true, message: '请输入沟通内容' }]}>
                    <Input.TextArea 
                      placeholder="请输入沟通内容" autoComplete="off" className="textarea-content" rows={4} 
                    />
                  </Form.Item>

                  <Form.Item label="联系方式" name="tools" className="formItem-tools" rules={[{ required: false }]}>
                    <Select placeholder="请选择联系方式" className="select-tools">
                        <Select.Option value="微信">微信</Select.Option>
                        <Select.Option value="手机">手机</Select.Option>
                        <Select.Option value="固话">固话</Select.Option>
                        <Select.Option value="邮件">邮件</Select.Option>
                        <Select.Option value="现场拜访">线下拜访</Select.Option>
                        <Select.Option value="其他">其他</Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item label="呼入/呼出" name="way" className="formItem-tools" rules={[{ required: false }]}>
                    <Select placeholder="请选择呼入/呼出" className="select-tools">
                        <Select.Option value={0}>Out</Select.Option>
                        <Select.Option value={1}>In</Select.Option>
                    </Select>
                  </Form.Item>
                 
                  <Form.Item label="备注信息" name="remark" className="formItem-introduction" rules={[{ required: false }]}>
                    <Input.TextArea 
                      placeholder="请输入备注信息" autoComplete="off" className="textarea-introduction" rows={4} 
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" className="button-contact_submit" htmlType="submit" loading={this.state.loading} >
                      提交
                    </Button>
                  </Form.Item>
                </Form>
              </div>   
          </Card>
        </div> 
      </ErrorBoundary>: ""
    );
  }
}

export default ContactManagerPage;